import { Box, CircularProgress } from '@mui/material';
import { useEffect } from 'react';

import { writeTokens } from '../api/storage';

/**
 * Where a provider sign-in lands.
 *
 * The API redirected here with the token pair in the fragment — never the query string, which is sent to
 * servers, written to access logs and carried by `Referer`. This stores it and reloads, with
 * `location.replace` so the address holding a live refresh token does not stay in history (R0148).
 *
 * A refusal — an address with no back-office account — arrives here with no tokens, and goes back to the
 * sign-in screen. It is not treated as an error worth a message: it is the same answer a wrong password
 * gets, and saying more would tell an outsider whether an address is staff.
 */
export const OauthLandingPage = () => {
  useEffect(() => {
    const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const accessToken = fragment.get('accessToken');
    const refreshToken = fragment.get('refreshToken');

    if (accessToken === null || refreshToken === null || accessToken === '' || refreshToken === '') {
      window.location.replace('/login');

      return;
    }

    writeTokens(accessToken, refreshToken);
    window.location.replace('/');
  }, []);

  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
};
